<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <ion-header>
    <ion-toolbar>
      <ion-title>{{ $t('general.client_info') }}</ion-title>
      <ion-buttons slot="end">
        <ion-button @click="closeModal()">
          <ion-icon
            slot="icon-only"
            :icon="close"
          />
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <form
      ref="form"
      @submit.prevent="onSubmit"
    >
      <ion-list>
        <ion-radio-group
          v-model="client.salutation"
        >
          <ion-item class="client ion-margin-horizontal">
            <ion-radio
              name="salutation"
              required
              value="mr"
            >
              {{ $t('general.salutation_mr') }}
            </ion-radio>
          </ion-item>
          <ion-item class="client ion-margin-horizontal">
            <ion-radio
              name="salutation"
              required
              value="mrs"
            >
              {{ $t('general.salutation_mrs') }}
            </ion-radio>
          </ion-item>
          <input
            type="text"
            name="salutation"
            required
            class="sr-only w-full"
            :value="client.salutation"
          />
        </ion-radio-group>
      </ion-list>
      <ion-item
        lines="none"
        class="client ion-margin-top ion-margin-horizontal"
      >
        <ion-label position="stacked">
          {{ $t('order.customer_name') }}
        </ion-label>
        <ion-input
          v-model="client.customer_name"
          :aria-label="$t('order.customer_name')"
          required
        />
      </ion-item>
      <ion-item
        lines="none"
        class="client ion-margin-top ion-margin-horizontal"
      >
        <ion-label position="stacked">
          {{ $t('order.last_no') }}
        </ion-label>
        <ion-input
          v-model="client.mold_number"
          :aria-label="$t('order.last_no')"
          required
        />
      </ion-item>
      <ion-button
        type="submit"
        expand="block"
        class="client"
      >
        {{ buttonText || $t('form.save') }}
      </ion-button>
    </form>
  </ion-content>
</template>

<script>
import { defineComponent } from 'vue';
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonInput,
  IonRadio,
  IonRadioGroup,
  modalController,
} from '@ionic/vue';
import { close } from 'ionicons/icons';
import UserMixin from '@/mixins/UserMixin';
import store from '@/store';

export default defineComponent({
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonTitle,
    IonInput,
    IonRadio,
    IonRadioGroup,
    IonToolbar,
  },
  mixins: [UserMixin],
  props: {
    buttonText: {
      type: String,
      required: false,
      default: null,
    },
    onConfirm: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup() {
    return {
      close,
      store,
    };
  },
  data() {
    return {
      client: {
        ...store.cart.client,
      },
    };
  },
  methods: {
    /**
     * Close modal.
     */
    async closeModal() {
      await modalController.dismiss();
    },
    /**
     * Store client in cart.
     */
    onSubmit() {
      this.store.cart.client = this.client;
      this.closeModal();
      if (this.onConfirm) {
        this.onConfirm(this.client);
      }
    },
  },
});
</script>

<style scoped>
ion-item::part(native) {
  padding: unset;
}

ion-item.client {
  margin-right: 6px !important;
}

ion-button.client {
  margin-right: 16px !important;
  margin-left: 16px !important;
}

ion-content {
  ion-input {
    --padding-top: 12px !important;
    --padding-bottom: 12px !important;
  }

  ion-button {
    margin: 20px 26px 20px 20px;

    --border-radius: 5px;
  }
}
</style>
